import config from "config/appConfig";

import type { IStateProps } from "utils/StateOf";
import createStoreFunction from "utils/createStore";

import type { LoyaltyLevelModel, LoyaltyStoreModel } from "../../types/LoyaltyModel";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.LOYALTY_DATA}`;

export interface Values {
	loading: boolean;

	loadingLevels: boolean;
	levels: LoyaltyLevelModel[];

	loadingStores: boolean;
	stores: LoyaltyStoreModel[];
}

export const initialState: IStateProps<Values> = {
	loading: false,

	loadingLevels: false,
	levels: [],

	loadingStores: false,
	stores: []
};

export default createStoreFunction<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey
});
